module.exports = __webpack_public_path__ + "img/logo-header-grey.2a288a7f.png";